export const baseTheme = {
  typography: {
    family: {
      MTSWide: 'MTS Wide, sans-serif',
      MTSCompact: 'MTS Compact, sans-serif',
      // MTSText: 'MTS Text, sans-serif',
      // MTSSans: 'MTS Sans, sans-serif',
      // MTSExtended: 'MTS Extended',
    },

    size: {
      rem: {
        display: '6rem',
        h1: '4.5rem',
        h2: '4rem',
        h3: '3rem',
        h4: '2.25rem',
        h5: '1.875rem',
        h6: '1.5rem',
        pL: '1.25rem',
        pM: '1.125rem',
        pS: '1rem',
        captionL: '0.875rem',
        captionM: '0.75rem',
        captionS: '0.625rem',
      },
      px: {
        display: '96px',
        h1: '72px',
        h2: '64px',
        h3: '48px',
        h4: '36px',
        h5: '30px',
        h6: '24px',
        pL: '20px',
        pM: '18px',
        pS: '16px',
        captionL: '14px',
        captionM: '12px',
        captionS: '10px',
      },
    },

    lineHeight: {
      rem: {
        display: '6.25rem',
        h1: '5rem',
        h2: '4.5rem',
        h3: '3.5rem',
        h4: '2.75rem',
        h5: '2.25rem',
        h6: '2rem',
        pL: '1.75rem',
        pM: '1.625rem',
        pS: '1.5rem',
        captionL: '1.25rem',
        captionM: '1rem',
        captionS: '0.875rem',
        captionXS: '0.75rem',
      },
      px: {
        display: '100px',
        h1: '80px',
        h2: '72px',
        h3: '56px',
        h4: '44px',
        h5: '36px',
        h6: '32px',
        pL: '28px',
        pM: '26px',
        pS: '24px',
        captionL: '20px',
        captionM: '16px',
        captionS: '14px',
        captionXS: '12px',
      },
    },

    letterSpacing: {
      rem: {
        display: '-0.225rem',
        h1: '-0.138rem',
        h2: '-0.106rem',
        h3: '-0.063rem',
        h4: '-0.044rem',
        h5: '-0.031rem',
        h6: '-0.019rem',
        pL: '-0.013rem',
        pM: '-0.013rem',
        pS: '-0.013rem',
        captionL: '-0.006rem',
        captionM: '0rem',
        captionS: '0rem',
      },
      px: {
        display: '-3.6px',
        h1: '-2.208px',
        h2: '-1.696px',
        h3: '-1.008px',
        h4: '-0.704px',
        h5: '-0.496px',
        h6: '-0.304px',
        pL: '-0.208px',
        pM: '-0.208px',
        pS: '-0.208px',
        captionL: '-0.096px',
        captionM: '0px',
        captionS: '0px',
      },
    },

    weight: {
      regular: 400,
      medium: 500,
      bold: 700,
      black: 900,
    },
  },
}
